<astral-typeahead [control]="control" [itemsSource]="itemsSource" [helpText]="helpText" [clearOthers]="clearOthers"></astral-typeahead>
